<div class="ibox" style="border: 1px solid #e7eaec; border-radius: 4px; margin: 8px; padding: 10px; background-color: #ffffff; box-sizing: border-box; width: 100%; max-width: 100%; overflow: hidden;">
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="form-horizontal m-t">
      <div class="row">
        <div class="col-sm-5">
          <div class="form-group">
            <label class="col-sm-3 control-label"> LPGA ID: </label>
            <div class="col-sm-9">
              <input
                type="number"
                class="form-control"
                name="lpgaId"
                [value]="player.lpgaId"
                readonly
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label"> WWGR ID: </label>
              <div class="col-sm-9">
                <input
                  type="number"
                  class="form-control"
                  name="wwgrId"
                  [(ngModel)]="player.wwgrId"
                  (ngModelChange)="onPlayerFieldChanged()"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Active:</label>
                <div class="col-sm-9">
                  <div class="checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="isActive"
                        [(ngModel)]="player.isActive"
                        (ngModelChange)="onPlayerFieldChanged()"
                        />
                        Player is active
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label">Short Name:</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      name="shortName"
                      [(ngModel)]="player.shortName"
                      (ngModelChange)="onPlayerFieldChanged()"
                      />
                    </div>
                  </div>
                  <div hidden class="form-group">
                    <label class="col-sm-3 control-label">Play First Name:</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        name="playFirstName"
                        [(ngModel)]="player.playFirstName"
                        (ngModelChange)="onPlayerFieldChanged()"
                        />
                      </div>
                    </div>
                    <div hidden class="form-group">
                      <label class="col-sm-3 control-label">Play Middle Name:</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          class="form-control"
                          name="playMiddleName"
                          [(ngModel)]="player.playMiddleName"
                          (ngModelChange)="onPlayerFieldChanged()"
                          />
                        </div>
                      </div>
                      <div hidden class="form-group">
                        <label class="col-sm-3 control-label">Play Last Name:</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            name="playLastName"
                            [(ngModel)]="player.playLastName"
                            (ngModelChange)="onPlayerFieldChanged()"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-3 control-label">First Name:</label>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              class="form-control"
                              name="firstName"
                              [(ngModel)]="player.firstName"
                              (ngModelChange)="onPlayerFieldChanged()"
                              />
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-sm-3 control-label">Middle Name:</label>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                class="form-control"
                                name="middleName"
                                [(ngModel)]="player.middleName"
                                (ngModelChange)="onPlayerFieldChanged()"
                                />
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-3 control-label">Last Name:</label>
                              <div class="col-sm-9">
                                <input
                                  type="text"
                                  class="form-control"
                                  name="lastName"
                                  [(ngModel)]="player.lastName"
                                  (ngModelChange)="onPlayerFieldChanged()"
                                  />
                                </div>
                              </div>

                              <div hidden class="form-group">
                                <label class="col-sm-3 control-label">City:</label>
                                <div class="col-sm-9">
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="city"
                                    [(ngModel)]="player.city"
                                    (ngModelChange)="onPlayerFieldChanged()"
                                    />
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-3 control-label">Country:</label>
                                  <div class="col-sm-9">
                                    <div class="btn-group">
                                      <button
                                        type="button"
                                        class="btn btn-default dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        >
                                        {{ player.countryName }}
                                        <span class="caret"></span>
                                      </button>
                                      <ul class="dropdown-menu">
                                        @for (country of countries; track country) {
                                          <li
                    (click)="
                      player.countryId = country.countryId;
                      player.countryName = country.name;
                      onPlayerFieldChanged()
                    "
                                            >
                                            <a href="javascript:void(0)">{{ country.name }}</a>
                                          </li>
                                        }
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="col-sm-3 control-label">Hometown:</label>
                                  <div class="col-sm-9">
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="hometown"
                                      [(ngModel)]="player.hometown"
                                      (ngModelChange)="onPlayerFieldChanged()"
                                      />
                                    </div>
                                  </div>
                                  <div hidden class="form-group">
                                    <label class="col-sm-3 control-label">State:</label>
                                    <div class="col-sm-9">
                                      <div class="btn-group">
                                        <button
                                          type="button"
                                          class="btn btn-default dropdown-toggle"
                                          data-toggle="dropdown"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                          >
                                          {{ player.stateName }}
                                          <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                          @for (state of states; track state) {
                                            <li
                    (click)="
                      player.stateId = state.stateId;
                      player.stateName = state.name;
                      onPlayerFieldChanged()
                    "
                                              >
                                              <a href="javascript:void(0)">{{ state.name }}</a>
                                            </li>
                                          }
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-5">
                                  <div class="form-group">
                                    <label class="col-sm-3 control-label">Player Types:</label>
                                    <div class="col-sm-9">
                                      @for (playerType of playerTypes; track playerType) {
                                        <div class="checkbox">
                                          <label>
                                            <input
                                              type="checkbox"
                                              [checked]="playerType.selected"
                                              disabled
                                              />
                                              Is {{ playerType.name }}
                                            </label>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-3 control-label">Created On:</label>
                                      <div class="col-sm-9">
                                        <app-audit-info [dateUtc]="player.createdOnUtc"></app-audit-info>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-3 control-label">Modified On:</label>
                                      <div class="col-sm-9">
                                        <app-audit-info [dateUtc]="player.modifiedOnUtc"></app-audit-info>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="text-right">
                                    <button class="btn btn-primary m-t m-r" (click)="save()" [disabled]="!canSave">
                                      <i class="fa fa-save"></i> Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
